var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClear = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 16.41 16.41",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1.41 16.41 6.8-6.79L15 16.41 16.41 15 9.62 8.21l6.79-6.8L15 0 8.21 6.79 1.41 0 0 1.41l6.79 6.8L0 15z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgClear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clear.2f6e9088af9fed2d863d3b9c117fff98.svg";